import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';

export function AgreementTypeValue({ deal, agreementTypes }) {
  let value;
  if (deal.agreementType) {
    const agreementTypeOption = agreementTypes.find(type => type.value === deal.agreementType);
    value = agreementTypeOption.label;

  }

  return <Value name="agreementType" value={value} />;
}

AgreementTypeValue.propTypes = {
  agreementTypes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  deal: PropTypes.shape({
    agreementType: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  agreementTypes: state.options.agreementType,
});

export default connect(mapStateToProps)(AgreementTypeValue);
